<template>
	<div id="itemGalleryImage" class="itemGalleryImage">
		<Carousel :per-page="1" :autoplay="true" :navigationEnabled="true" :loop="true">
			<slide v-if="ptInitData.productInfo.IMG_URL1 != '' && ptInitData.productInfo.IMG_URL1 != undefined">
				<img :src="ptInitData.productInfo.IMG_URL1" @error="getErrImage"
					:alt="$t('pt125.labels.imageProduct') + '1'" class="imgProduct" />
			</slide>
			<slide v-if="ptInitData.productInfo.IMG_URL2 != '' && ptInitData.productInfo.IMG_URL2 != undefined">
				<img :src="ptInitData.productInfo.IMG_URL2" @error="getErrImage"
					:alt="$t('pt125.labels.imageProduct') + '2'" class="imgProduct" />
			</slide>
			<slide v-if="ptInitData.productInfo.IMG_URL3 != '' && ptInitData.productInfo.IMG_URL3 != undefined">
				<img :src="ptInitData.productInfo.IMG_URL3" @error="getErrImage"
					:alt="$t('pt125.labels.imageProduct') + '3'" class="imgProduct" />
			</slide>
			<slide v-if="ptInitData.productInfo.IMG_URL4 != '' && ptInitData.productInfo.IMG_URL4 != undefined">
				<img :src="ptInitData.productInfo.IMG_URL4" @error="getErrImage"
					:alt="$t('pt125.labels.imageProduct') + '4'" class="imgProduct" />
			</slide>
			<slide v-if="ptInitData.productInfo.IMG_URL5 != '' && ptInitData.productInfo.IMG_URL5 != undefined">
				<img :src="ptInitData.productInfo.IMG_URL5" @error="getErrImage"
					:alt="$t('pt125.labels.imageProduct') + '5'" class="imgProduct" />
			</slide>
			<slide v-if="ptInitData.productInfo.IMG_URL6 != '' && ptInitData.productInfo.IMG_URL6 != undefined">
				<img :src="ptInitData.productInfo.IMG_URL6" @error="getErrImage"
					:alt="$t('pt125.labels.imageProduct') + '6'" class="imgProduct" />
			</slide>
			<slide v-if="ptInitData.productInfo.IMG_URL7 != '' && ptInitData.productInfo.IMG_URL7 != undefined">
				<img :src="ptInitData.productInfo.IMG_URL7" @error="getErrImage"
					:alt="$t('pt125.labels.imageProduct') + '7'" class="imgProduct" />
			</slide>
			<slide v-if="ptInitData.productInfo.IMG_URL8 != '' && ptInitData.productInfo.IMG_URL8 != undefined">
				<img :src="ptInitData.productInfo.IMG_URL8" @error="getErrImage"
					:alt="$t('pt125.labels.imageProduct') + '8'" class="imgProduct" />
			</slide>
			<slide v-if="ptInitData.productInfo.IMG_URL9 != '' && ptInitData.productInfo.IMG_URL9 != undefined">
				<img :src="ptInitData.productInfo.IMG_URL9" @error="getErrImage"
					:alt="$t('pt125.labels.imageProduct') + '9'" class="imgProduct" />
			</slide>
		</Carousel>
	</div>
</template>
<script>

import { Carousel, Slide } from 'vue-carousel';
import common from "assets/js/common";
export default {
	name: 'itemGalleryImage',
	props: {
		ptInitData: {
			type: Object,
			default: null
		}
	},
	components:{Carousel, Slide},
	data() {
		return {
			errImage: false
		}
	},
	methods: {
		/**
	 * exec load url default when load main image is error
	 * @param {Any} event, event exec error
	 */
		getErrImage(event) {
			//get image default
			event.target.src = common.getImgDefault();
		},
	}
}
</script>